
import { useContext, useRoute } from '@nuxtjs/composition-api';
import useShoppingList from '@/composable/useShoppingList';
import useTracking from '~/composable/tracking/useTracking'

export default {
  setup(_props, { emit }) {
    const { app } = useContext()
    const route = useRoute()
    const channelSplit = route.value.query.channelsplit
    const subscriptionId = route.value.params.subscriptionid
    let selectedMixServices = route.value.query.tlmmix
    selectedMixServices = selectedMixServices !== undefined ? selectedMixServices?.split(',') : selectedMixServices
    const {
      parentChildSubscriptionsInShoppingList,
      shoppingList,
      shoppingListTotal,
      buyFamilySubscription,
      getFamilySubscriptionName,
      getDisplayPerMonthPrice,
      getTotalMonthlyDiscount
    } = useShoppingList(app)
    const { track } = useTracking()
    const trackData = ({ interactionLabel, interactionComponent }) => {
      track('familyConceptBuy', { interactionLabel, interactionComponent, parentSubscription: parentChildSubscriptionsInShoppingList.value.parentSubscription, childSubscriptions: parentChildSubscriptionsInShoppingList.value.childSubscriptions })
    }
    const deleteButtonClicked = (listItem) => {
      emit('updateQuantity', { event: { value: -1, count: listItem.quantity - 1 }, channelKey: listItem.sku })
    }

    return {
      subscriptionId,
      channelSplit,
      selectedMixServices,
      trackData,
      getDisplayPerMonthPrice,
      deleteButtonClicked,
      buyFamilySubscription,
      shoppingListTotal,
      getFamilySubscriptionName,
      shoppingList,
      getTotalMonthlyDiscount
    }
  }
}
